import * as Config from '../../../config';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import './ArtistLabel.css';

import CoverSplit from '../common/CoverSplit';
import Content from '../common/Content';
import ListV2 from '../content/list/ListV2'
import Spinner from '../common/Spinner';
import GridCharts from '../content/grid/GridCharts';
import GridReleases from '../content//grid/GridReleases';
import ListColumns from '../content/list/ListColumns';
import TrendsV2 from '../trends/TrendsV2';
import SubMenu from '../common/SubMenu';
// import RadioButton from '../automix/RadioButton';
import AutomixStandAloneButton from '../automix/AutomixStandAloneButton';

import useGetOne from '../../../hooks/useGetOne';
import usePageScroll from '../../../hooks/usePageScroll';
import useArtistCharts from './hooks/useArtistCharts';

const STICKY_HEADER_ARTIST_LABEL_HEIGHT = 55; //65;
function ConnectedArtistLabel({
  type, pathItem, pathReleases, pathTop, pathTracks, pathCharts,
  style, api, dimension,
  myBeatportStore,
}) {
  const { item } = useGetOne(api, pathItem, null);
  const globalHistory = useHistory();
  let { url } = useRouteMatch();
  const { width, height } = dimension;

  if (!pathItem) { globalHistory.push(`/`) }

  const aTrends = useMemo(() => {
    let base = (type === `Artist`) ? [ {
        id: `artists`, type: 'artists', title: `Related Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: true, isRanked: false,
        grid: {
          rowWidth: 142, //135
          rowHeight: 165, //145,
          rowPadding: 4,
          coverBorder: 4,
          gap: 8,
          hasPagination: true,
          blockClassName: 'card-artist',
          coverClassName: 'cover-artist'
        }
      }
    ] : [{
      id: `top_artists`, type: 'artists', title: `Top Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: false, isRanked: true, limit: 20,
      grid: {
        rowWidth: 142, //135
        rowHeight: 165, //145,
        rowPadding: 4,
        coverBorder: 4,
        gap: 8,
        hasPagination: false,
        blockClassName: 'card-artist',
        coverClassName: 'cover-artist'
      }
    }, {
        id: `artists`,  type: 'artists', title: `Related Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: true, isRanked: false,
        grid: {
          rowWidth: 142, //135
          rowHeight: 165, //145,
          rowPadding: 4,
          coverBorder: 4,
          gap: 8,
          hasPagination: true,
          blockClassName: 'card-artist',
          coverClassName: 'cover-artist'
        }
      }
    ];
    if (Config.TRENDS_ARTIST_LABEL_MORE && type === `Artist`) {
      base.push({
        id: `labels`, type: 'labels', title: `Related Labels`, props: [`release|label`], format: `formattedLabel`, isRandom: true, isRanked: false,
        grid: {
          rowWidth: 142, //135
          rowHeight: 168, //158 //138,
          rowPadding: 8,
          coverBorder: 0,
          gap: 8,
          hasPagination: true,
          blockClassName: 'card-label',
          coverClassName: 'cover-label'
        }
      });
      base.push({
        id: `genres`, type: 'genres', title: `Related Genres`, props: [`genre`], format: `formattedGenre`, isRandom: false, isRanked: false, limit: 10,
        grid: {
          rowWidth: 100,
          rowHeight: 40,
          gap: 12,
          hasPagination: false,
          showAll: true,
          className: 'grid-list-genres',
        }
      });
    }
    return base;
  }, [type])

  const hasRadio = (!window.location.pathname.includes(`tracks`) && !window.location.pathname.includes(`top`) && !window.location.pathname.includes(`releases`) && !window.location.pathname.includes(`charts`) )
  let { onScroll } = usePageScroll();

  const haveCharts = useArtistCharts((item && item.dj_association) ? item.dj_association : null);

  return (!item)
    ? <Spinner />
    : (
        <div className={`global-page`} style={{ height }} onScroll={onScroll}>
          <Content name={item.name} isSticky={true} showTitle={false}
            stickyClassName={`global-sticky-menu sticky-menu-artists-labels`}
            contentClassName={`content-artist-label`}
            styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
            subContent={(
              <div className='flexRow' style={{gap: 4, marginLeft: 25}}>                
                <CoverSplit 
                  name={item.name} 
                  images={[(item.image && item.image.uri) ? item.image.uri : Config.DEFAULT_IMG]} 
                  size={80} 
                  className={`cover-${type.toLowerCase()}`} 
                  onlyCover={true}
                />
                <div className={`flexColumn global-menu space-around`} style={{gap: 0}}>
                  <div className={'flexRow align'}>
                    <span className={'title-artist-label'}>{item.name}</span>
                    { myBeatportStore && myBeatportStore.setButtonFollow(item.id, type, myBeatportStore[type.toLowerCase()].includes(item.id)) }
                  </div>
                  <div className={`flexRow slider-menu`}>
                    <SubMenu to={`${url}/featured`} or={`${url}`} label={`Featured`} />
                    <SubMenu to={`${url}/tracks`} label={`Tracks`} />
                    <SubMenu to={`${url}/releases`} label={`Releases`} />
                    {(type === `Artist` && item && item.dj_association && haveCharts) && <SubMenu to={`${url}/charts`} label={`Charts`} />}
                    <SubMenu to={`${url}/top`} label={`Top 100`} />
                  </div>
                </div>
                {/* {hasRadio && <RadioButton className={'discover-radio-button'} />} */}
                {hasRadio && <AutomixStandAloneButton pathApi={`${pathTop}/?per_page=100`}  uid={`${item.name} - Top 100`} from={`${url}/top`} className={`artist-label-automix-button ${Config.API_NAME}`} isShow={true} />}
              </div>
            )}
          >
            <Switch>
              <Route exact path={[`${url}`, `${url}/featured`]}>
                <div className={`flexRow artist-grid-container`}>
                  <GridReleases
                    id={`{A}artist_last_release`}
                    title={`Latest Release`}
                    width={Config.ARTIST_LABEL_COVER_RELEASE}
                    height={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)}
                    columnWidth={Config.ARTIST_LABEL_COVER_RELEASE}
                    columnCount={1}
                    rowCount={1}
                    rowHeight={Config.CARD_HEIGHT + Config.GRID_PAD}
                    style={{ marginRight: 20 }}
                    className={`grid-last-release`}
                    pathApi={`${pathReleases}&per_page=1`} 
                  />
                  <ListColumns
                    title={`Top 10`}
                    pathApi={pathTop}
                    linkToUID={`${item.name} - Top 100`}
                    id={`{B}listC-${pathTop}`}
                    width={width - Config.CARD_WIDTH - (Config.GRID_PAD * 2)}
                    height={(Config.LIST_ROW_HEIGHT * 5)}
                    size={Config.LIST_ROW_HEIGHT}
                    columnCount={2}
                    rowCount={5}
                    rowType={`Column`}
                    hasPagination={false} allTo={`${url}/top`} allLabel={`View Top 100`}
                    enableArrows={true}
                  />
                </div>
                { type === `Artist` ? (
                  <TrendsV2
                    pathApi={`${pathTop}/?per_page=100`}
                    className={`trends-artist-label`}
                    width={width}
                    exceptIds={item.id}
                    params={aTrends}
                  />
                ) : null }
                { type === `Label` ? (
                  <TrendsV2
                    pathApi={`${pathTop}/?per_page=100`}
                    width={width}
                    exceptIds={item.id}
                    params={aTrends}
                  />
                ) : null }
              </Route>
              <Route exact path={[`${url}/top`]}>
                <ListV2
                  pathApi={`${pathTop}/?per_page=100`}
                  sortable={false}
                  id={`artist_label_top`}
                  width={width}
                  height={height - (Config.TAB_BAR_GUTTER * 5.6) - STICKY_HEADER_ARTIST_LABEL_HEIGHT}
                  size={Config.LIST_ROW_HEIGHT}
                  isLoadMore={false}
                  type={`Full#`}
                  style={{marginTop: 16}}
                  filtersStyle={{position: `absolute`, top: 50 /*23*/, right: 279}}
                  panelStyle={{ margin: `0px 0px 16px 0px` }}
                  orderBy={[`release`, `top`, `title`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
                  filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
                  isBoost={true}
                  automix={true}
                  automixName={`${item.name} - Top 100`}
                  automixStyle={{ position: `absolute`, top: 50 /*23*/, left: `auto`, right: 0 }}
                  from={`${url}/top`}
                  enableShortcuts={true}
                  enableSave={true}
                  saveName={`${item.name} - Top 100`}
                />
              </Route>
              <Route exact path={[`${url}/tracks`]}>
                <ListV2
                  pathApi={`${pathTracks}`}
                  sortable={false}
                  id={`artist_label_tracks`}
                  width={width}
                  height={height - Config.STICKY_HEADER_HEIGHT - STICKY_HEADER_ARTIST_LABEL_HEIGHT}
                  size={Config.LIST_ROW_HEIGHT}
                  isLoadMore={true}
                  type={`Full`}
                  style={{marginTop: 85}}
                  filtersStyle={{position: `absolute`, top: 50 /*23*/, right: 127}}
                  panelStyle={{ margin: `0px 0px 16px 0px` }}
                  orderBy={[`title`, `label`, `genre_s`, `release`]}
                  filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `publish_date`, `bpm`, `key_convert`/*, 'preorders'*/]}
                  automix={true}
                  automixName={`${item.name} - Tracks`}
                  automixStyle={{ position: `absolute`, top: 50 /*23*/, left: `auto`, right: 0 }}
                />
              </Route>
              <Route exact path={[`${url}/releases`]}>
                <GridReleases id={`artist_all_releases`} width={width}
                  hasFilters={true} buttonFilterStyle={{ top: 50 /*23*/ }} filtersStyle={{ top: 60, height: 250 }}
                  height={ height - (Config.TAB_BAR_GUTTER * 5) - STICKY_HEADER_ARTIST_LABEL_HEIGHT }
                  perPage={100} pathApi={`${pathReleases}&per_page=100`}
                  style={{ marginTop: 12 }} className={`grid-chart all no-border`} showLoading={true}
                  filtersConfig={[`release_name`, `artists_s`, `remixers_s`, `label`, `publish_date`]}
                />   
              </Route>
              <Route exact path={[`${url}/charts`]}>
                <GridCharts id={`artist_all_charts`} width={width}
                  hasFilters={true} buttonFilterStyle={{ top: 50 /*23*/ }} filtersStyle={{ top: 60, height: 250 }}
                  height={ height - (Config.TAB_BAR_GUTTER * 5) - STICKY_HEADER_ARTIST_LABEL_HEIGHT }
                  perPage={100} pathApi={`${pathCharts}&per_page=100&dj_id=${item.dj_association}`}
                  style={{ marginTop: 12 }} className={`grid-chart all no-border`}
                />
              </Route>
            </Switch>
          </Content>
        </div>
    )
}

ConnectedArtistLabel.propTypes = {
  type: PropTypes.string.isRequired,
  pathItem: PropTypes.string.isRequired,
  pathReleases: PropTypes.string.isRequired,
  pathTop: PropTypes.string.isRequired,
  pathTracks: PropTypes.string.isRequired,
  pathCharts: PropTypes.string,
  isScrolling: PropTypes.bool,
  style: PropTypes.object
}

const ArtistLabel = connect(
  state => ({
    api: state.api,
    dimension: state.dimension,
    myBeatportStore: state.MBStore,
  })
)(ConnectedArtistLabel);

export default ArtistLabel;
